<template>
  <BaseSection
    heading="Pensionsplaner"
    :infoStatus="avtal.infoStatus"
    :show-error="!!avtal.error"
  >
    <div class="spinner-wrapper" v-if="avtal.isLoading"><SmallSpinner /></div>
    <avtalat-table
      v-if="!avtal.isLoading"
      :headings="headings"
      :striped="false"
    >
      <avtalat-table-row
        v-for="(plan, index) in avtal.data?.pensionsplaner"
        :key="index"
      >
        <avtalat-table-cell>{{ plan.namn }}</avtalat-table-cell>
        <avtalat-table-cell>{{ plan.giltigFrom }}</avtalat-table-cell>
        <avtalat-table-cell>{{ plan.giltigTom || "Tillsvidare" }}</avtalat-table-cell>
        <avtalat-table-cell class="text-right">{{
          plan.pensionsalder
        }}</avtalat-table-cell>
      </avtalat-table-row>
    </avtalat-table>
  </BaseSection>
</template>

<script setup lang="ts">
import { computed } from "vue";

import SmallSpinner from "@/components/ui/SmallSpinner.vue";
import { BaseSection } from "@/components/sections";

import { useArbetsgivareStore } from "../store";

const arbetsgivareStore = useArbetsgivareStore();
const avtal = computed(() => arbetsgivareStore.avtal);

const headings = [
  {
    content: "Pensionsplan",
  },
  {
    content: "Gäller från",
  },
  {
    content: "Gäller till",
  },
  {
    content: "Pensionsålder",
    align: "right",
  },
];
</script>

<style scoped>
.spinner-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
</style>
